import {
  addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, Timestamp, updateDoc,
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';

// Email campaigns drafted and sent from the admin panel ("campaigns").
const campaignsCollection = () => collection(db, 'campaigns');
const campaignRef = (id) => doc(db, 'campaigns', id);

/** Newest first, with createdAt/updatedAt/sentAt as Dates (sentAt null until sent). */
export async function listCampaigns() {
  const snapshot = await getDocs(query(campaignsCollection(), orderBy('createdAt', 'desc')));
  return snapshot.docs.map((snap) => {
    const data = snap.data();
    return {
      id: snap.id,
      ...data,
      createdAt: data.createdAt?.toDate?.() || new Date(),
      updatedAt: data.updatedAt?.toDate?.() || new Date(),
      sentAt: data.sentAt?.toDate?.() || null,
    };
  });
}

export async function createCampaign(data) {
  const now = Timestamp.now();
  const ref = await addDoc(campaignsCollection(), { ...data, createdAt: now, updatedAt: now });
  return ref.id;
}

export function updateCampaign(id, data) {
  return updateDoc(campaignRef(id), { ...data, updatedAt: Timestamp.now() });
}

export function deleteCampaign(id) {
  return deleteDoc(campaignRef(id));
}

export function markCampaignSent(id, { recipientCount, sentCount }) {
  return updateDoc(campaignRef(id), { status: 'sent', sentAt: Timestamp.now(), recipientCount, sentCount });
}
